document.addEventListener('DOMContentLoaded', function () {
    initAppFeaturesSlider();
    setupAppFeaturesAnimations();
    updateContainerPadding();
    window.addEventListener('resize', function () {
      updateContainerPadding();
    });
  });
  
  function initAppFeaturesSlider() {
    var screenWidth = window.innerWidth;
    var appFeaturesConfig = {
      navigation: {
        nextEl: '.appFeatures__buttonWrapper .swiper-button-next',
        prevEl: '.appFeatures__buttonWrapper .swiper-button-prev',
      },
      direction: 'horizontal',
      pagination: {
        el: '.appFeatures__scrollbar .swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.1,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 1.1,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 3.1,
          spaceBetween: 20,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3.1,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
      },
      speed: 500,
      spaceBetween: 20,
      slidesPerGroup: 1,
      freeMode: false,
      loop: false,
    };

    if (screenWidth > 900) {
      appFeaturesConfig.mousewheel = {
        invert: false,
        forceToAxis: true,
      };
    } else {
      appFeaturesConfig.mousewheel = {
        invert: false,
        forceToAxis: true,
      };
      appFeaturesConfig.slidesPerView = 1;
    }
  
    var appFeaturesSwiper = new Swiper('.appFeatures__wrapper', appFeaturesConfig);
    var nextButton = document.querySelector('.appFeatures__buttonWrapper .swiper-button-next');
    var prevButton = document.querySelector('.appFeatures__buttonWrapper .swiper-button-prev');
    
    if (nextButton) {
      nextButton.replaceWith(nextButton.cloneNode(true));
      nextButton = document.querySelector('.appFeatures__buttonWrapper .swiper-button-next');
      
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        appFeaturesSwiper.params.speed = 200;
        
        var nextIndex = appFeaturesSwiper.activeIndex + 1;
        if (nextIndex <= appFeaturesSwiper.slides.length - 1) {
          appFeaturesSwiper.slideTo(nextIndex);
        }
        return false;
      });
    }
    
    if (prevButton) {
      prevButton.replaceWith(prevButton.cloneNode(true));
      prevButton = document.querySelector('.appFeatures__buttonWrapper .swiper-button-prev');
      
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        appFeaturesSwiper.params.speed = 200;
        
        var prevIndex = appFeaturesSwiper.activeIndex - 1;
        if (prevIndex >= 0) {
          appFeaturesSwiper.slideTo(prevIndex);
        }
        return false;
      });
    }
  }
  
  function getContentLeftDistance(el) {
    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);
    var borderLeftWidth = parseFloat(style.borderLeftWidth) || 0;
    var paddingLeft = parseFloat(style.paddingLeft) || 0;
    return rect.left + borderLeftWidth + paddingLeft;
  }
  
  function updateContainerPadding() {
    var containerElement = document.querySelector('.appFeatures__container.page-width');
    var wrapperElement = document.querySelector('.appFeatures__wrapper.swiper');
    if (!containerElement || !wrapperElement) return;
    // 获取容器的计算样式
    var containerStyle = window.getComputedStyle(containerElement);
    var containerPaddingLeft = parseFloat(containerStyle.paddingLeft) || 0;
    var containerMarginLeft = parseFloat(containerStyle.marginLeft) || 0;
    var containerPaddingRight = parseFloat(containerStyle.paddingRight) || 0;
    var containerMarginRight = parseFloat(containerStyle.marginRight) || 0;
    var totalLeftSpacing = containerPaddingLeft + containerMarginLeft;
    var totalRightSpacing = containerPaddingRight + containerMarginRight;
    wrapperElement.style.paddingLeft = totalLeftSpacing + 'px';
    wrapperElement.style.paddingRight = totalRightSpacing + 'px';
    var stickyMenu = document.getElementById('position_sticky-menu');
    if (stickyMenu) {
      var stickyDistance = getContentLeftDistance(stickyMenu);
      if (stickyDistance > 0) {
        wrapperElement.style.paddingLeft = Math.max(stickyDistance, totalLeftSpacing) + 'px';
      }
    }
  }
  
  function setupAppFeaturesAnimations() {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.2,
      }
    );
    const items = document.querySelectorAll('.appFeatures__section.key_feature_position');
    items.forEach((item) => observer.observe(item));
  } 